import React, { useEffect, useState } from "react";
import { Button, Modal } from "reactstrap";
import { FILTER } from "../../../constant";
import { Table, TableRow } from "../../../components/Table";
import BlockChargebackCustomerModal from "./BlockChargebackCustomerModal";
import * as XLSX from "xlsx";
import { useRole } from "../../../redux/slices/authSlice";

const CustomerDetailsParseModal = (props) => {
    const { data, onClose, onGet } = props;

    const [filter, setFilter] = useState(FILTER);
    const [tableData, setTableData] = useState([]);
    const [filterColumns, setFilterColumns] = useState([]);
    const [blockCustomer, setBlockCustomer] = useState(false);
    const [isBlockCustomerId, setIsBlockCustomerId] = useState("");
    const role = useRole("Deposit");

    const COLUMN_ORDER = [
        { title: "Transaction ID", key: "Transaction ID" },
        { title: "UTR", key: "UTR" },
        { title: "Order ID", key: "Order ID" },
        { title: "Customer UPI", key: "Customer UPI" },
        { title: "Pg Name", key: "Pg Name" },
        { title: "Pg Label", key: "Pg Label" },
        { title: "Pg UPI", key: "Pg UPI" },
        { title: "Customer ID", key: "Customer ID" },
        { title: "Amount", key: "Amount" },
        { title: "State", key: "State" },
        { title: "Date", key: "Date" },
        { title: "Client Name", key: "Client Name" },
    ];


    useEffect(() => {
        const { limit, page_no } = filter;

        setTableData(
            data?.parsedData?.length
                ? data?.parsedData?.slice(
                    limit * (page_no - 1),
                    limit * (page_no - 1) + limit
                )
                : []
        );
    }, [data, filter]);

    useEffect(() => {
        if (data?.parsedData?.length > 0) {
            const cols = [...COLUMN_ORDER.map(col => col.key)];

            if (role?.includes("deposit-block-customer")) {
                cols.push("action");
            }

            setFilterColumns(cols);
        }
    }, [data, role]);


    const isNullorObject = (value) => {
        if (value === null) {
            return "null";
        } else if (typeof value === "object" || typeof value === "function") {
            return "object";
        } else {
            return "not null or object";
        }
    };

    const onHide = () => {
        onClose();
        setTableData([]);
        setFilter(FILTER);
    };

    const onCloseBlockCustomerModal = (id) => {
        setBlockCustomer(!blockCustomer);
        setIsBlockCustomerId(id);
    };

    const handleDownload = () => {
        if (!data?.parsedData?.length) return;

        const dataToExport = data.parsedData.map(row => {
            const orderedRow = {};
            COLUMN_ORDER.forEach(col => {
                orderedRow[col.title] = row[col.key] ?? "-";
            });
            return orderedRow;
        });

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Details");
        XLSX.writeFile(workbook, "CustomerDetails.xlsx");
    };

    const columns = React.useMemo(() => {
        if (!data?.parsedData?.length) return [];

        const baseColumns = COLUMN_ORDER.map(col => ({
            title: col.title,
            name: col.key,
            Cell: (row) => row?.[col.key] ?? "-"
        }));

        if (role?.includes("deposit-block-customer")) {
            baseColumns.push({
                title: "ACTION",
                name: "action",
                Cell: (row) => (
                    <Button
                        className="filterbtn btn-smallsize"
                        disabled={row?.isBlockedCust}
                        onClick={() => {
                            const id = row?.["Transaction ID"];
                            onCloseBlockCustomerModal(id);
                        }}
                    >
                        {row?.isBlockedCust ? "Blocked Customer" : "Block Customer"}
                    </Button>
                ),
            });
        }

        return baseColumns;
    }, [data, role]);

    return (
        <>
            <Modal
                className="add-manual-payout-modal modal-xl"
                isOpen={isNullorObject(data) !== "null"}
                toggle={onHide}
                centered={true}
            >
                <div className="modal-header">
                    <h3 className="modal-title mt-0">Parse Data</h3>
                    <div className="d-flex align-items-center button-space">
                        {role?.includes("deposit-block-customer") && (
                            <Button
                                color="danger"
                                className="btn-sm"
                                onClick={() => onCloseBlockCustomerModal("all")}
                            >
                                Block All Customer
                            </Button>
                        )}
                        <Button color="success" className="btn-sm" onClick={handleDownload}>
                            XLSX Download
                        </Button>
                        <i
                            onClick={() => {
                                onHide();
                            }}
                            className="fa-solid fa-xmark cursor-pointer"
                        ></i>
                    </div>
                </div>
                <div className="modal-body">
                    <Table
                        columns={columns}
                        data={tableData || []}
                        isData={!!tableData?.length}
                        isExpandable={false}
                        filterColumns={filterColumns}
                        count={data?.parsedData?.length}
                        pagination={filter}
                        handlePaginationChange={(pagination) => {
                            setFilter({
                                ...filter,
                                ...pagination,
                            });
                        }}
                    >
                        {tableData?.map((items, index) => {
                            return (
                                <TableRow
                                    key={index}
                                    columns={columns}
                                    filterColumns={filterColumns}
                                    item={items}
                                    isExpandable={false}
                                />
                            );
                        })}
                    </Table>
                </div>
                <div className="modal-footer">
                    <div className="d-flex justify-content-end button-space">
                        <Button
                            className="graybutton"
                            onClick={() => {
                                onHide();
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal>
            <BlockChargebackCustomerModal
                blockCustomer={blockCustomer}
                isBlockCustomerId={isBlockCustomerId}
                chargeBackId={data?.id}
                onCloseBlockCustomerModal={() => setBlockCustomer(false)}
                onGet={onGet}
            />
        </>
    );
};

export default CustomerDetailsParseModal;
